module.exports = __webpack_public_path__ + "img/ss_pink-10.eb81bbc3.jpg";